export enum EQueryKey {
  inspectionQuery = 'inspectionQuery',
  // Inspections
  inspection = 'inspection',
  inspectionHistory = 'inspectionHistory',
  inspections = 'inspections',
  // Assets
  asset = 'asset',
  assets = 'assets',
  customerSitesAssets = 'customerSitesAssets',
  // Customers and Sites
  customers = 'customers',
  sites = 'sites',
  mineLocations = 'mineLocations',
  // Equipment and Parts
  equipment = 'equipment',
  equipmentParts = 'equipmentParts',
  inspectionAssetEquipment = 'inspectionAssetEquipment',
  // Static data
  assetManufacturers = 'assetManufacturers',
  assetModels = 'assetModels',
  assetTypes = 'assetTypes',
  partTypes = 'partTypes',
}

// Query key factory functions for consistent key generation
export const queryKeys = {
  // Inspections
  inspection: (externalId: string) =>
    [EQueryKey.inspection, externalId] as const,
  inspectionHistory: (assetId: number, cutoffDate: Date) =>
    [EQueryKey.inspectionHistory, assetId, cutoffDate.toISOString()] as const,
  inspections: () => [EQueryKey.inspections] as const,

  // Assets
  asset: (id: number) => [EQueryKey.asset, id] as const,
  assets: (siteId?: number) =>
    siteId ? [EQueryKey.assets, siteId] : ([EQueryKey.assets] as const),
  customerSitesAssets: (customerId?: number, siteId?: number) =>
    [EQueryKey.customerSitesAssets, customerId, siteId] as const,

  // Customers and Sites
  customers: () => [EQueryKey.customers] as const,
  sites: (customerId?: number) =>
    customerId ? [EQueryKey.sites, customerId] : ([EQueryKey.sites] as const),
  mineLocations: (siteId?: number) =>
    siteId
      ? [EQueryKey.mineLocations, siteId]
      : ([EQueryKey.mineLocations] as const),

  // Equipment and Parts
  equipment: (assetId?: number) =>
    assetId ? [EQueryKey.equipment, assetId] : ([EQueryKey.equipment] as const),
  equipmentParts: (equipmentId?: string) =>
    equipmentId
      ? [EQueryKey.equipmentParts, equipmentId]
      : ([EQueryKey.equipmentParts] as const),
  inspectionAssetEquipment: (inspectionId: string) =>
    [EQueryKey.inspectionAssetEquipment, inspectionId] as const,

  // Static data
  assetManufacturers: () => [EQueryKey.assetManufacturers] as const,
  assetModels: () => [EQueryKey.assetModels] as const,
  assetTypes: () => [EQueryKey.assetTypes] as const,
  partTypes: () => [EQueryKey.partTypes] as const,
};
